// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logoloop {
  position: relative;

  --logoloop-gap: 32px;
  --logoloop-logoHeight: 28px;
  --logoloop-fadeColorAuto: #ffffff;
}

.logoloop--vertical {
  height: 100%;
  display: inline-block;
}

.logoloop--scale-hover {
  padding-top: calc(var(--logoloop-logoHeight) * 0.1);
  padding-bottom: calc(var(--logoloop-logoHeight) * 0.1);
}

@media (prefers-color-scheme: dark) {
  .logoloop {
    --logoloop-fadeColorAuto: #0b0b0b;
  }
}

.logoloop__track {
  display: flex;
  width: max-content;
  will-change: transform;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  z-index: 0;
}

.logoloop--vertical .logoloop__track {
  flex-direction: column;
  height: max-content;
  width: 100%;
}

.logoloop__list {
  display: flex;
  align-items: center;
}

.logoloop--vertical .logoloop__list {
  flex-direction: column;
}

.logoloop__item {
  flex: 0 0 auto;
  margin-right: var(--logoloop-gap);
  font-size: var(--logoloop-logoHeight);
  line-height: 1;
}

.logoloop--vertical .logoloop__item {
  margin-right: 0;
  margin-bottom: var(--logoloop-gap);
}

.logoloop__item:last-child {
  margin-right: var(--logoloop-gap);
}

.logoloop--vertical .logoloop__item:last-child {
  margin-right: 0;
  margin-bottom: var(--logoloop-gap);
}

.logoloop__node {
  display: inline-flex;
  align-items: center;
}

.logoloop__item img {
  height: var(--logoloop-logoHeight);
  width: auto;
  display: block;
  object-fit: contain;
  image-rendering: -webkit-optimize-contrast;
  -webkit-user-drag: none;
  pointer-events: none;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.logoloop--scale-hover .logoloop__item {
  overflow: visible;
}

.logoloop--scale-hover .logoloop__item:hover img,
.logoloop--scale-hover .logoloop__item:hover .logoloop__node {
  transform: scale(1.2);
  transform-origin: center center;
}

.logoloop--scale-hover .logoloop__node {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.logoloop__link {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  border-radius: 4px;
  transition: opacity 0.2s ease;
}

.logoloop__link:hover {
  opacity: 0.8;
}

.logoloop__link:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 2px;
}

.logoloop--fade::before,
.logoloop--fade::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: clamp(24px, 8%, 120px);
  pointer-events: none;
  z-index: 10;
}

.logoloop--fade::before {
  left: 0;
  background: linear-gradient(
    to right,
    var(--logoloop-fadeColor, var(--logoloop-fadeColorAuto)) 0%,
    rgba(0, 0, 0, 0) 100%
  );
}

.logoloop--fade::after {
  right: 0;
  background: linear-gradient(
    to left,
    var(--logoloop-fadeColor, var(--logoloop-fadeColorAuto)) 0%,
    rgba(0, 0, 0, 0) 100%
  );
}

.logoloop--vertical.logoloop--fade::before,
.logoloop--vertical.logoloop--fade::after {
  left: 0;
  right: 0;
  width: 100%;
  height: clamp(24px, 8%, 120px);
}

.logoloop--vertical.logoloop--fade::before {
  top: 0;
  bottom: auto;
  background: linear-gradient(
    to bottom,
    var(--logoloop-fadeColor, var(--logoloop-fadeColorAuto)) 0%,
    rgba(0, 0, 0, 0) 100%
  );
}

.logoloop--vertical.logoloop--fade::after {
  bottom: 0;
  top: auto;
  background: linear-gradient(
    to top,
    var(--logoloop-fadeColor, var(--logoloop-fadeColorAuto)) 0%,
    rgba(0, 0, 0, 0) 100%
  );
}

@media (prefers-reduced-motion: reduce) {
  .logoloop__track {
    transform: translate3d(0, 0, 0) !important;
  }

  .logoloop__item img,
  .logoloop__node {
    transition: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/logoloop.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;;EAElB,oBAAoB;EACpB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mDAAmD;EACnD,sDAAsD;AACxD;;AAEA;EACE;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,0CAA0C;EAC1C,uBAAuB;EACvB,oBAAoB;EACpB,uDAAuD;AACzD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,6BAA6B;EAC7B,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,OAAO;EACP;;;;GAIC;AACH;;AAEA;EACE,QAAQ;EACR;;;;GAIC;AACH;;AAEA;;EAEE,OAAO;EACP,QAAQ;EACR,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,MAAM;EACN,YAAY;EACZ;;;;GAIC;AACH;;AAEA;EACE,SAAS;EACT,SAAS;EACT;;;;GAIC;AACH;;AAEA;EACE;IACE,0CAA0C;EAC5C;;EAEA;;IAEE,2BAA2B;EAC7B;AACF","sourcesContent":[".logoloop {\n  position: relative;\n\n  --logoloop-gap: 32px;\n  --logoloop-logoHeight: 28px;\n  --logoloop-fadeColorAuto: #ffffff;\n}\n\n.logoloop--vertical {\n  height: 100%;\n  display: inline-block;\n}\n\n.logoloop--scale-hover {\n  padding-top: calc(var(--logoloop-logoHeight) * 0.1);\n  padding-bottom: calc(var(--logoloop-logoHeight) * 0.1);\n}\n\n@media (prefers-color-scheme: dark) {\n  .logoloop {\n    --logoloop-fadeColorAuto: #0b0b0b;\n  }\n}\n\n.logoloop__track {\n  display: flex;\n  width: max-content;\n  will-change: transform;\n  user-select: none;\n  position: relative;\n  z-index: 0;\n}\n\n.logoloop--vertical .logoloop__track {\n  flex-direction: column;\n  height: max-content;\n  width: 100%;\n}\n\n.logoloop__list {\n  display: flex;\n  align-items: center;\n}\n\n.logoloop--vertical .logoloop__list {\n  flex-direction: column;\n}\n\n.logoloop__item {\n  flex: 0 0 auto;\n  margin-right: var(--logoloop-gap);\n  font-size: var(--logoloop-logoHeight);\n  line-height: 1;\n}\n\n.logoloop--vertical .logoloop__item {\n  margin-right: 0;\n  margin-bottom: var(--logoloop-gap);\n}\n\n.logoloop__item:last-child {\n  margin-right: var(--logoloop-gap);\n}\n\n.logoloop--vertical .logoloop__item:last-child {\n  margin-right: 0;\n  margin-bottom: var(--logoloop-gap);\n}\n\n.logoloop__node {\n  display: inline-flex;\n  align-items: center;\n}\n\n.logoloop__item img {\n  height: var(--logoloop-logoHeight);\n  width: auto;\n  display: block;\n  object-fit: contain;\n  image-rendering: -webkit-optimize-contrast;\n  -webkit-user-drag: none;\n  pointer-events: none;\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.logoloop--scale-hover .logoloop__item {\n  overflow: visible;\n}\n\n.logoloop--scale-hover .logoloop__item:hover img,\n.logoloop--scale-hover .logoloop__item:hover .logoloop__node {\n  transform: scale(1.2);\n  transform-origin: center center;\n}\n\n.logoloop--scale-hover .logoloop__node {\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.logoloop__link {\n  display: inline-flex;\n  align-items: center;\n  text-decoration: none;\n  border-radius: 4px;\n  transition: opacity 0.2s ease;\n}\n\n.logoloop__link:hover {\n  opacity: 0.8;\n}\n\n.logoloop__link:focus-visible {\n  outline: 2px solid currentColor;\n  outline-offset: 2px;\n}\n\n.logoloop--fade::before,\n.logoloop--fade::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: clamp(24px, 8%, 120px);\n  pointer-events: none;\n  z-index: 10;\n}\n\n.logoloop--fade::before {\n  left: 0;\n  background: linear-gradient(\n    to right,\n    var(--logoloop-fadeColor, var(--logoloop-fadeColorAuto)) 0%,\n    rgba(0, 0, 0, 0) 100%\n  );\n}\n\n.logoloop--fade::after {\n  right: 0;\n  background: linear-gradient(\n    to left,\n    var(--logoloop-fadeColor, var(--logoloop-fadeColorAuto)) 0%,\n    rgba(0, 0, 0, 0) 100%\n  );\n}\n\n.logoloop--vertical.logoloop--fade::before,\n.logoloop--vertical.logoloop--fade::after {\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: clamp(24px, 8%, 120px);\n}\n\n.logoloop--vertical.logoloop--fade::before {\n  top: 0;\n  bottom: auto;\n  background: linear-gradient(\n    to bottom,\n    var(--logoloop-fadeColor, var(--logoloop-fadeColorAuto)) 0%,\n    rgba(0, 0, 0, 0) 100%\n  );\n}\n\n.logoloop--vertical.logoloop--fade::after {\n  bottom: 0;\n  top: auto;\n  background: linear-gradient(\n    to top,\n    var(--logoloop-fadeColor, var(--logoloop-fadeColorAuto)) 0%,\n    rgba(0, 0, 0, 0) 100%\n  );\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .logoloop__track {\n    transform: translate3d(0, 0, 0) !important;\n  }\n\n  .logoloop__item img,\n  .logoloop__node {\n    transition: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
